<div class="container auth-container">
  <div class="auth-card">
    <h2 class="auth-title">Təsdiq kodu</h2>
    <p class="auth-subtitle"><b>{{phoneNumber}}</b> nömrəsinə göndərilən 6 rəqəmli kodu daxil edin.</p>

    <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-group">
        <label>Təsdiq kodu</label>
        <div class="otp-input-container">
          <input
            type="text"
            id="otp1"
            formControlName="otp1"
            maxlength="1"
            (input)="onInput($event, 'otp2')"
            (keydown)="onKeyDown($event, null)"
            (paste)="onPaste($event)"
            autocomplete="one-time-code"
          >
          <input
            type="text"
            id="otp2"
            formControlName="otp2"
            maxlength="1"
            (input)="onInput($event, 'otp3')"
            (keydown)="onKeyDown($event, 'otp1')"
          >
          <input
            type="text"
            id="otp3"
            formControlName="otp3"
            maxlength="1"
            (input)="onInput($event, 'otp4')"
            (keydown)="onKeyDown($event, 'otp2')"
          >
          <input
            type="text"
            id="otp4"
            formControlName="otp4"
            maxlength="1"
            (input)="onInput($event, 'otp5')"
            (keydown)="onKeyDown($event, 'otp3')"
          >
          <input
            type="text"
            id="otp5"
            formControlName="otp5"
            maxlength="1"
            (input)="onInput($event, 'otp6')"
            (keydown)="onKeyDown($event, 'otp4')"
          >
          <input
            type="text"
            id="otp6"
            formControlName="otp6"
            maxlength="1"
            (input)="onInput($event, null)"
            (keydown)="onKeyDown($event, 'otp5')"
          >
        </div>
        <div class="error-message" *ngIf="otpForm.invalid && otpForm.touched">
          <span>Zəhmət olmasa bütün rəqəmləri düzgün daxil edin.</span>
        </div>
      </div>

      <button type="submit" class="btn-submit" [disabled]="otpForm.invalid">Təsdiq et</button>

      <div class="resend-section">
        <button type="button" class="btn-resend" [disabled]="timer > 0" (click)="resendCode()">
          Kodu yenidən göndər <span *ngIf="timer > 0">({{timer}}s)</span>
        </button>
      </div>
    </form>
  </div>
</div>
